// Storage utility to handle both localStorage and sessionStorage
// Impersonation windows use sessionStorage to avoid affecting other windows

export const getToken = () => {
  // Check if this is an impersonation window
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    return sessionStorage.getItem('token');
  }
  return localStorage.getItem('token');
};

export const getRefreshToken = () => {
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    return sessionStorage.getItem('refreshToken');
  }
  return localStorage.getItem('refreshToken');
};

export const getUser = () => {
  // Check if this is an impersonation window
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    const userStr = sessionStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const setToken = (token) => {
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    sessionStorage.setItem('token', token);
  } else {
    localStorage.setItem('token', token);
  }
};

export const setRefreshToken = (refreshToken) => {
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    sessionStorage.setItem('refreshToken', refreshToken);
  } else {
    localStorage.setItem('refreshToken', refreshToken);
  }
};

export const setUser = (user) => {
  const userStr = typeof user === 'string' ? user : JSON.stringify(user);
  if (sessionStorage.getItem('isImpersonationWindow') === 'true') {
    sessionStorage.setItem('user', userStr);
  } else {
    localStorage.setItem('user', userStr);
  }
};

export const removeToken = () => {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
};

export const removeRefreshToken = () => {
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('refreshToken');
};

export const removeUser = () => {
  localStorage.removeItem('user');
  sessionStorage.removeItem('user');
};

export const isImpersonationWindow = () => {
  return sessionStorage.getItem('isImpersonationWindow') === 'true';
};

// Clear all auth data
export const clearAuthData = () => {
  removeToken();
  removeRefreshToken();
  removeUser();
};
